import type { TourConfig } from '@components/tours/types';
import { BATCH_TOUR_IDS } from './constants';

export const batchGeneralTour: TourConfig = {
  id: 'batch-general',
  name: 'Batch Details Tour',
  description: 'Learn about the batch details screen and its key elements',
  steps: [
    {
      tourId: BATCH_TOUR_IDS.DETAILS_BLOCK,
      popover: {
        title: 'Batch Details',
        description: 'This section displays all the key information about the current batch, including batch number, link status, and ready quantity.',
      },
    },
    {
      tourId: BATCH_TOUR_IDS.BATCH_NUMBER,
      popover: {
        title: 'Batch Number',
        description: 'The unique identifier for this batch. Click to view detailed batch information and history.',
      },
    },
    {
      tourId: BATCH_TOUR_IDS.BATCH_LINK,
      popover: {
        title: 'Batch Link',
        description: 'Shows the connection between this batch and production orders. Linked batches can be tracked and reported on.',
      },
    },
    {
      tourId: BATCH_TOUR_IDS.READY_QUANTITY,
      popover: {
        title: 'Ready Quantity',
        description: 'Shows the number of completed pieces versus the target quantity. This helps track production progress.',
      },
    },
    {
      tourId: BATCH_TOUR_IDS.PRODUCTIVITY_STATUS_BLOCK,
      popover: {
        title: 'Productivity Status',
        description: 'Displays the current machine status (<span style="display:inline-block;width:10px;height:10px;background:#34C759;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Active, <span style="display:inline-block;width:10px;height:10px;background:#AF52DE;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Setup, <span style="display:inline-block;width:10px;height:10px;background:#FF9500;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Change, <span style="display:inline-block;width:10px;height:10px;background:#8E8E93;border-radius:2px;margin:0 2px;vertical-align:middle;"></span> Not Productive) and time tracking for the current operation.',
      },
    },
    {
      tourId: BATCH_TOUR_IDS.BATCH_STATUS_BLOCK,
      popover: {
        title: 'Batch Status',
        description: 'Shows whether the batch is Running, Paused, Finished, or Closed. Also displays the timeline and duration.',
      },
    },
  ],
};
